<template>
<div class="footer">
  <div>
    <p>@2020
    <span> BioEnergy China </span>All Rights Reserved</p>
  </div>
  <p><a class="footer-a" href="https://beian.miit.gov.cn/#/Integrated/index/">苏ICP备20045703号</a></p>
    <a class="footer-a" href>
      <img src="../assets/images/guohui.png" />苏公安网备 32058302002766号
    </a>

</div>
</template>

<script>
export default {
  name: 'webfooter'
}
</script>

<style scoped>
  .footer {
    background-color: #001528;
    text-align: center;
  //flex-flow: 14px;
    color: #999999;
    padding: 18px 36px;
  //line-height: 60 px;
  }
  .footer div {
    display: contents;
  }
  .footer div span {
    color: #0068b7;
  }

  .footer a {
    display: contents;
    padding: 5px;
    color: #fff;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/webfooter.vue